/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */
/* istanbul ignore file */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { NavService } from '../../sharedServices/nav.service';
import { UserHandlerService } from '../../sharedServices/user-handler.service';

@Component({
  selector: 'app-header-component',
  templateUrl: './header-component.component.html',
  styleUrls: ['./header-component.component.css']
})
export class HeaderComponentComponent implements OnInit, OnDestroy {
  refreshSubscription: Subscription;
  userEmail: string;
  userRights: string;

  constructor(
    private readonly authentificationService: AuthentificationService,
    private readonly userHandlerService: UserHandlerService,
    private readonly navService: NavService) {
    this.userHandlerService.currentUserChanged.subscribe(() => {
      const currentUser = this.userHandlerService.getCurrentUser();
      this.userEmail = currentUser.email;
      this.userRights = currentUser.role;
    });
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  logout() {
    this.authentificationService.logout();
  }

  toggleSideNav() {
    this.navService.toggle();
  }
}
